import { rest, type RestRequest, type DefaultBodyType, type RestHandler } from 'msw';

export const createHandler = (
    restMethod: keyof typeof rest,
    endpoint: string,
    status: number,
    responseData: DefaultBodyType,
    delayResponse = false,
): {
    handler: RestHandler;
    resolve: (value?: unknown) => void;
    getLastRequest: () => RestRequest;
} => {
    let resolve: (value?: unknown) => void = () => undefined;
    let request: RestRequest;

    const promise = new Promise(resolveFn => {
        resolve = resolveFn;
    });

    const handler = rest[restMethod](endpoint, async (req, res, ctx) => {
        request = req;
        await promise;
        return res(ctx.status(status), ctx.json(responseData));
    });

    if (!delayResponse) {
        resolve();
    }

    const getLastRequest = () => request;

    return {
        // The handler is the specServer.use so that handler will be used to handle
        // this request when it is made
        handler,

        // If delayResponse is true, then the request will not automatically be resolved.
        // It will only be resolved once resolve() is called.  This allows for checking the
        // state of the UI while the request is in flight
        resolve,
        getLastRequest,
    };
};

export const createGetSuccessHandler = (endpoint: string, response: DefaultBodyType, delayResponse = false) =>
    createHandler('get', endpoint, 200, response, delayResponse);

export const createPutSuccessHandler = (endpoint: string, response: DefaultBodyType, delayResponse = false) =>
    createHandler('put', endpoint, 200, response, delayResponse);

export const createPostSuccessHandler = (endpoint: string, response: DefaultBodyType, delayResponse = false) =>
    createHandler('post', endpoint, 200, response, delayResponse);
